module.exports = __webpack_public_path__ + "img/line-friend-qrcode.4d1eb0c8.png";